import { useState } from "react";


import { FaEye, FaEyeSlash } from "react-icons/fa";

function ForgotPassword({ onBack }) {
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [errors, setErrors] = useState({});
    const [submitted, setSubmitted] = useState(false);
    const [showNewPass, setShowNewPass] = useState(false);
    const [showConfirmPass, setShowConfirmPass] = useState(true);

    const validate = () => {
        const err = {};
        if (!newPassword.trim()) {
            err.newPassword = "New password is required";
        } else if (newPassword.length < 6) {
            err.newPassword = "Password must be at least 6 characters";
        }

        if (!confirmPassword.trim()) {
            err.confirmPassword = "Confirm your password";
        } else if (confirmPassword !== newPassword) {
            err.confirmPassword = "Passwords do not match";
        }

        return err;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const validationErrors = validate();
        setErrors(validationErrors);

        if (Object.keys(validationErrors).length === 0) {
            setSubmitted(true);
            setTimeout(() => {
                onBack(); // simulate success and go back to login
            }, 2000);
        }
    };

    return (
        <div

        >

            <div style={styles.container}>
                <form onSubmit={handleSubmit} style={styles.form}>
                    <h2 style={styles.title}>Reset Password</h2>

                    {!submitted ? (
                        <>
                            <div style={styles.inputContainer}>
                                <input
                                    type={showNewPass ? "text" : "password"}
                                    placeholder="New Password"
                                    value={newPassword}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                    style={styles.input}
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowNewPass(!showNewPass)}
                                    style={styles.eyeButton}
                                >
                                    {/* {showNewPass ? <FaEyeSlash /> : <FaEye />} */}
                                </button>
                            </div>
                            {errors.newPassword && <p style={styles.error}>{errors.newPassword}</p>}

                            <div style={styles.inputContainer}>
                                <input
                                    type={showConfirmPass ? "text" : "password"}
                                    placeholder="Confirm Password"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    style={styles.input}
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowConfirmPass(!showConfirmPass)}
                                    style={styles.eyeButton}
                                >
                                    {/* {showConfirmPass ? <FaEyeSlash /> : <FaEye />} */}
                                </button>
                            </div>
                            {errors.confirmPassword && (
                                <p style={styles.error}>{errors.confirmPassword}</p>
                            )}

                            <button type="submit" style={styles.primaryButton}>
                                Update Password
                            </button>

                            <button type="button" onClick={onBack} style={styles.linkButton}>
                                ← Back to Login
                            </button>
                        </>
                    ) : (
                        <>
                            <p style={{ marginBottom: 20, textAlign: "center", color: "#333" }}>
                                ✅ Password successfully updated!
                            </p>
                            <button type="button" onClick={onBack} style={styles.primaryButton}>
                                Back to Login
                            </button>
                        </>
                    )}
                </form>
            </div>
        </div>
    );
}

const styles = {
    container: {
        height: "100vh",
        width: "100%",
        backgroundColor: "#f0f2f5",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: 20,
        // backgroundImage: "url('https://img.freepik.com/free-vector/isometric-erp-illustration_52683-84174.jpg?ga=GA1.1.1338093985.1743762455&semt=ais_hybrid&w=740')",
        backgroundImage: "url('https://images.unsplash.com/photo-1557683304-673a23048d34')",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
    },
    form: {
        backgroundColor: "#fff",
        padding: "40px 30px",
        borderRadius: "12px",
        boxShadow: "0 8px 30px rgba(0, 0, 0, 0.1)",
        width: "100%",
        maxWidth: "400px",
        display: "flex",
        flexDirection: "column",
    },
    title: {
        textAlign: "center",
        marginBottom: 30,
        color: "#333",
    },
    inputContainer: {
        position: "relative",
        width: "100%",
        marginBottom: 16,
    },
    input: {
        width: "100%",
        padding: "12px 40px 12px 12px",
        borderRadius: 8,
        border: "1px solid #ccc",
        fontSize: 16,
    },
    eyeButton: {
        position: "absolute",
        right: 10,
        top: "50%",
        transform: "translateY(-50%)",
        background: "none",
        border: "none",
        cursor: "pointer",
        padding: 0,
        color: "#888",
    },
    error: {
        color: "red",
        fontSize: "13px",
        marginTop: -10,
        marginBottom: 10,
    },
    primaryButton: {
        padding: "12px",
        backgroundColor: "#1976d2",
        color: "white",
        border: "none",
        borderRadius: 8,
        fontSize: 16,
        cursor: "pointer",
        marginTop: 10,
    },
    linkButton: {
        background: "none",
        color: "#1976d2",
        border: "none",
        fontSize: 14,
        cursor: "pointer",
        marginTop: 15,
        textDecoration: "underline",
    },
};

export default ForgotPassword;
